<div class="btn-group" placement="bottom right">
  <button
    id="navbarDropdown"
    data-toggle="dropdown"
    aria-haspopup="true"
    aria-expanded="false"
    class="btn btn-lg btn-primary"
  >
    <span>{{ username }}</span
    >&nbsp;
    <span class="lgi lgi-account-circle text-muted"> </span>
  </button>
  <ul
    class="dropdown-menu"
    [class.dropdown-menu-right]="!isDashboard"
    aria-labelledby="navbarDropdown"
  >
    <li role="menuitem">
      <a class="dropdown-item" (click)="logout()">{{
        "BUTTON_LOGOUT" | translate
      }}</a>
    </li>
  </ul>
</div>
